import type { Presence } from '@goanna-im/shared';

export function ConnectionBadge({
  connected,
  presence,
}: {
  connected: boolean;
  presence: Presence[];
}) {
  const producers = presence.filter((p) => p.role === 'producer').length;
  const presenters = presence.filter((p) => p.role === 'presenter').length;
  return (
    <span
      className="tag"
      role="status"
      aria-live="polite"
      aria-label={connected ? 'Connected' : 'Disconnected'}
    >
      <span className={`dot ${connected ? 'on' : 'off'}`} aria-hidden="true" />
      {connected ? 'Live' : 'Offline'}
      <span className="muted" aria-hidden="true">
        · {presenters}▣ {producers}▤
      </span>
    </span>
  );
}
